"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRedirectQuery = exports.getNextRedirectUrl = exports.getRootUrl = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _links = _interopRequireDefault(require("hub-pickers-lib/utils/links"));

var getRootUrl = function getRootUrl() {
  return '/myaccounts-beta';
};

exports.getRootUrl = getRootUrl;

var getNextRedirectUrl = function getNextRedirectUrl(query) {
  if (!query) {
    return undefined;
  }

  if (query.next && _links.default[query.next]) {
    return _links.default[query.next];
  }

  return undefined;
};
/**
 * Gets the query params attached to the redirect url. If the passed query
 * params contains 'next', the param is removed from the list. This is to
 * prevent sending the next param when redirecting
 */


exports.getNextRedirectUrl = getNextRedirectUrl;

var getRedirectQuery = function getRedirectQuery(query) {
  if (query.next) {
    // Deep copy query to avoid overwriting location.query
    var __ = query.next,
        rest = (0, _objectWithoutProperties2.default)(query, ["next"]);
    return rest;
  }

  return query;
}; // OR, if you require portalID:
// export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;


exports.getRedirectQuery = getRedirectQuery;